import Axios from 'axios';
import DataGrid, {
    Column,
    Export,
    FilterRow,
    Grouping,
    GroupPanel,
    Pager,
    Paging,
    Selection
} from 'devextreme-react/data-grid';
import RadioGroup from 'devextreme-react/radio-group';
import React, { useEffect, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import { onExporting } from '../../../../utils/DataGridExporter';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';
export default function AddModal({ modalNew, setModalNew, triger, setTriger }) {
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);
    const notify = (message) => toast.error(`${message}`);
    const [roleGroups, setRoleGroups] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [radioGroupVal, setRadioGroupVal] = useState()
    const [test, setTest] = useState([]);
    const pageSizes = [10, 25, 50, 100];
    const { t } = useFormatMessage();

    async function getRoleGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken).then((resp) => {

            resp.data.forEach(obj => {

                obj.checked = false

            })

            setRoleGroups(resp.data);

        }).catch((err) => {
            console.error(err);
            notifyError("Rol Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function createNewPermissionGroup() {
        const checkboxHolder = []
        var arr = Array.from(test);
        arr.forEach(checks => {
            checkboxHolder.push(checks)
        })
        if (validateObject(checkboxHolder)) {
            await Axios.post(`${goRiceUrl}/api/employee/createpermission`, {
                permission_group_description: document.getElementById("yetki-grup-adi").value,
                permission_group_name: document.getElementById("yetki-grup-adi").value,
                user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                roles: checkboxHolder
            }, getConfigToken).then((resp) => {
                if (resp.status === 200) {
                    setTriger(!triger)
                    setModalNew(false);
                    notifySuccess("Yetki Grubu başarıyla eklendi.");
                }
                else {
                    notifyError("Yetki Grubu eklenirken bir hata meydana geldi.");
                }
            }).catch((err) => {
                console.error(err);
                notifyError("Yetki Grubu eklenirken bir servis hatası meydana geldi.");
            })
        } else {
            setTimeout(() => {
                document.getElementById("saveButtonNew").disabled = false
            }, 1500)
        }

    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (modalNew === true) {
            getRoleGroups();
        }
    }, [modalNew])
    /* eslint-disable react-hooks/exhaustive-deps */


    const roleItems = [
        // { id: 0, text: 'Full Yazma Yekisi', value: "write" },
        { id: 1, text: 'Sadece Görme Yetkisi', value: "read" },
        { id: 2, text: 'Sadece Ekleme Yetkisi', value: "ADD" },
        { id: 3, text: 'Sadece Güncelleme Yetkisi', value: "update" },
        { id: 4, text: 'Sadece Silme Yetkisi', value: "delete" },
        { id: 5, text: 'Sadece Excel Export Yetkisi', value: "excel" },
        { id: 6, text: 'Tüm Rolleri Kaldır', value: "" }
    ];

    const validateObject = (checkboxHolder) => {
        var result = true
        if (document.getElementById("yetki-grup-adi").value === "") {
            result = false;
            notify("Yetki Grubu adı boş olamaz")
            return
        }
        if (checkboxHolder.length === 0) {
            result = false;
            notify("Yeki Grubu seçimi yapınız.")
            return
        }
        return result;
    }
    function currentlySelected(selections) {
        setTest(selections)
    }

    function typeOnChange(value) {
        const filterRoleGroups = []
        if (value === "read") {
            roleGroups.forEach((role) => {

                if (role.access_type === "READ")
                    filterRoleGroups.push(role.role_id)

            })

        } else if (value === "write") {

            roleGroups.forEach((role) => {
                if (role.access_type === "WRITE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "add") {
            roleGroups.forEach((role) => {
                if (role.access_type === "ADD")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "delete") {
            roleGroups.forEach((role) => {
                if (role.access_type === "DELETE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "update") {
            roleGroups.forEach((role) => {
                if (role.access_type === "UPDATE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "excel") {
            roleGroups.forEach((role) => {
                if (role.access_type === "EXCEL")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "") {
            filterRoleGroups.push()
        }
        setSelectedRowKeys(filterRoleGroups)
        setRadioGroupVal(value)
    }

    return (
        <Modal size="lg" isOpen={modalNew} toggle={() => { setModalNew(!modalNew); setSelectedRowKeys([]) }}>
            <ModalHeader toggle={() => { setModalNew(!modalNew); setSelectedRowKeys([]) }}>
                {t("Yeni Yetki Grubu Oluşturma Formu")}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg="12">
                        <div className="dx-fieldset">
                            <Row>
                                <div xl="12" className='mb-3' style={{ width: "750px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>
                                    <div style={{ fontSize: "18px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Grup Bilgileri")}</div>
                                </div>
                            </Row>
                            <div className="dx-field mb-4">
                                <div className="dx-field-label" style={{ color: "black" }}>{t("Yetki Grubu Adı")}</div>
                                <div className="dx-field-value">
                                    <Input id="yetki-grup-adi" />
                                </div>
                            </div>
                            <Row>
                                <div className="option mb-4">

                                    <RadioGroup
                                        layout="horizontal"
                                        items={roleItems}
                                        value={radioGroupVal}
                                        valueExpr="value"
                                        displayExpr="text"
                                        itemRender={(item) => (
                                            <>
                                                {t(item.text)}
                                            </>
                                        )
                                        }
                                        onValueChanged={(e) => {
                                            typeOnChange(e.value)
                                        }}
                                    />

                                </div>
                            </Row>

                            <Row>
                                <Col xl="12" className='mb-4 ' style={{ width: "100px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>

                                    <div style={{ fontSize: "18px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Roller")}</div>

                                </Col>


                                <DataGrid
                                    className='datagrid gridContainer-style'
                                    dataSource={roleGroups}
                                    showBorders={true}
                                    onSelectedRowKeysChange={currentlySelected}
                                    selectedRowKeys={selectedRowKeys}
                                    allowColumnResizing={true}
                                    key="role_id"
                                    keyExpr="role_id"
                                    onExporting={onExporting}
                                >
                                    <Export enabled={true} />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={false} />
                                    <Selection
                                        mode="multiple"
                                        allowSelectAll={false}
                                    />
                                    {/* <Column dataField="Role_id" selectedFilterOperation={"contains"} alignment="center" /> */}
                                    <Column dataField="role_group_description" selectedFilterOperation={"contains"} caption={t("Yetki Grubu Adı")} alignment="center" groupIndex={0} />
                                    <Column dataField="role_description" selectedFilterOperation={"contains"} caption={t("Rol Adı")} alignment="center" />
                                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                    <Paging defaultPageSize={10} />

                                </DataGrid>
                            </Row>
                            {/*                                
                                <PerfectScrollbar style={{ paddingTop: 20, paddingBottom: 20, paddingRight: 20 }}>
                                    {roleGroups.map(roleGroup => (
                                        <>
                                            <Col xl="12" className='mb-4' style={{ color: "black", cursor: "pointer" }} onClick={() => {
                                                let classname = document.getElementById(roleGroup.RoleGroupId)
                                                if (classname.className === "collapse") {
                                                    classname.className = "collapse show";
                                                    document.getElementById(`${roleGroup.RoleGroupId}_arrow`).className = "fa fa-angle-down ml-2"
                                                } else if (classname.className === "collapse show") {
                                                    classname.className = "collapse";
                                                    document.getElementById(`${roleGroup.RoleGroupId}_arrow`).className = "fa fa-angle-right ml-2"
                                                } else {
                                                    classname.className = "collapse show";
                                                    document.getElementById(`${roleGroup.RoleGroupId}_arrow`).className = "fa fa-angle-down ml-2"
                                                }
                                            }} >{roleGroup.Description}
                                                <i id={`${roleGroup.RoleGroupId}_arrow`} className="fa fa-angle-right ml-2" />
                                            </Col>
                                            <br />
                                            <Collapse id={roleGroup.RoleGroupId}>
                                                <Card>
                                                    <CardBody>
                                                        <RoleTable dataSource={roleGroup.Roles} />
                                                    </CardBody>
                                                </Card>
                                            </Collapse>
                                        </>
                                    ))}
                                </PerfectScrollbar> */}

                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Col lg="12" className='d-flex justify-content-between align-items-center' >
                    <Button id='saveButtonNew' disabled={false} onClick={() => { createNewPermissionGroup(); document.getElementById("saveButtonNew").disabled = true }} >{t("Kaydet")}</Button>
                    <Button id='cancelButtonNew' color='danger' onClick={() => { setModalNew(false); setSelectedRowKeys([]) }} >{t("İptal")}</Button>
                </Col>
            </ModalFooter>
        </Modal>
    )
}